import { render, staticRenderFns } from "./StaticPageEditorLoader.vue?vue&type=template&id=0e9e5d39"
import script from "./StaticPageEditorLoader.vue?vue&type=script&lang=js"
export * from "./StaticPageEditorLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports